import React, { useEffect, useState } from "react";
import { useData } from "../components/context/data/DataState";
import { useParams } from "react-router-dom";
import { useAuth } from "../components/context/auth/AuthState";
import LeaderBoardBlock from "../components/Leaderboard/LeaderBoardBlock";
import api from "../services/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Label } from "../components/ui/label";

const LeaderBoard = () => {
  const { data, communityId, seasonId, challengeId } = useData();
  const { currentUser } = useAuth();
  const { community_id } = useParams();
  const [season_id, setseason_id] = useState("");
  const [challenge_id, setChallenge_id] = useState("");
  const [activity_id, setActivity_id] = useState("");

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (communityId === community_id && seasonId && seasonId !== -1 && seasonId !== "-1") {
      setseason_id(seasonId);
      setChallenge_id(challengeId);
      const cId = (challengeId && challengeId !== -1 && challengeId !== "-1") ? challengeId : "";
      handleChange(seasonId, cId);
    }
  }, [communityId, seasonId, challengeId, community_id]);

  const handleChange = async (
    seasonId = season_id,
    challengeId = challenge_id,
    activityId = activity_id
  ) => {
    if (!seasonId && !challengeId && !activityId) return;
    api.post("/score/read", {
      season_id: seasonId,
      challenge_id: challengeId,
      activity_id: activityId,
    })
      .then((res) => res.data)
      .then((data) => {
        console.log({ data });
        if (Array.isArray(data)) setTableData(data);
      });
  };

  if (!community_id) {
    return <div className="flex items-center justify-center h-64">Loading...</div>;
  }

  return (
    <div className="p-4 space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="season">Season</Label>
          <Select
            value={season_id}
            onValueChange={(value) => {
              setseason_id(value);
              handleChange(value);
            }}
          >
            <SelectTrigger id="season">
              <SelectValue placeholder="Select season" />
            </SelectTrigger>
            <SelectContent>
              {Object.values(data.community[community_id]?.season || {})
                .length === 0 && (
                  <SelectItem value="all">All</SelectItem>
                )}
              {data.community[community_id]?.season &&
                Object.values(data.community[community_id]?.season || {}).map(
                  (item) => (
                    <SelectItem value={item.season_id} key={item.season_id}>
                      {item.season_name}
                    </SelectItem>
                  )
                )}
            </SelectContent>
          </Select>
        </div>

        {season_id && (
          <div>
            <Label htmlFor="challenge">Challenge</Label>
            <Select
              value={challenge_id}
              onValueChange={(value) => {
                setChallenge_id(value);
                const cId = value === "all" ? "" : value;
                handleChange(undefined, cId, "");
                setActivity_id("");
              }}
            >
              <SelectTrigger id="challenge">
                <SelectValue placeholder="Select challenge" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Challenges</SelectItem>
                {data.community[community_id]?.season &&
                  Object.values(
                    data.community[community_id]?.season[season_id].challenge ||
                    {}
                  ).map((item) => (
                    <SelectItem value={item.challenge_id} key={item.challenge_id}>
                      {item.challenge_name}
                    </SelectItem>
                  ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </div>

      <div className="space-y-4">
        <div className="bg-primary/10 rounded-lg p-4">
          {tableData[0] &&
            tableData.map(
              (item, index) =>
                (item.user_id === currentUser.user_id || item.user_id === currentUser.uid) && (
                  <LeaderBoardBlock
                    item={item}
                    key={index}
                    community_id={community_id}
                    season_id={season_id}
                    challenge_id={challenge_id}
                    activity_id={activity_id}
                  />
                )
            )}
        </div>

        <div className="space-y-2">
          {tableData.map((item, index) => (
            <LeaderBoardBlock
              item={item}
              key={index}
              community_id={community_id}
              season_id={season_id}
              challenge_id={challenge_id}
              activity_id={activity_id}
            />
          ))}
        </div>

        {!season_id && (
          <div className="text-center text-gray-500 py-8">
            Choose a Season to Continue
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaderBoard;
